var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergencyHotline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2227_220)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2227_220",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2227_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6169 4.00044H15.5432V2.9267C15.5432 2.5498 15.2376 2.24414 14.8607 2.24414C14.4837 2.24414 14.1781 2.54973 14.1781 2.9267V4.00044H13.1044C12.7275 4.00044 12.4219 4.30603 12.4219 4.683C12.4219 5.05997 12.7275 5.36555 13.1044 5.36555H14.1781V6.43922C14.1781 6.81613 14.4837 7.12178 14.8607 7.12178C15.2376 7.12178 15.5432 6.81619 15.5432 6.43922V5.36555H16.6169C16.9938 5.36555 17.2995 5.05997 17.2995 4.683C17.2995 4.30603 16.9938 4.00044 16.6169 4.00044Z",
    fill: "#78787D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8786 10.2615L7.55187 8.59694C7.8184 8.33041 7.8184 7.89822 7.55187 7.63162L3.53415 3.61391C3.26756 3.34745 2.8355 3.34745 2.56883 3.61391L0.961764 5.22105C-0.0891457 6.27189 -0.286182 7.9958 0.406949 10.0751C1.04688 11.9949 2.38547 14.0384 4.17597 15.8289C6.84365 18.4965 9.88257 19.9967 12.1939 19.9967C13.2404 19.9967 14.1377 19.6891 14.7838 19.0431L16.3909 17.4359C16.6575 17.1694 16.6575 16.7372 16.3909 16.4706L12.3732 12.4529C12.1066 12.1864 11.6746 12.1864 11.4079 12.4529L9.74331 14.1262C9.39207 14.3029 8.26062 13.9986 7.13335 12.8713C6.00614 11.7441 5.7021 10.6126 5.8786 10.2615ZM11.8906 13.9009L14.943 16.9534L14.3012 17.5952L11.2488 14.5427L11.8906 13.9009ZM3.05153 5.06186L6.10399 8.11432L5.46217 8.75613L2.40971 5.70368L3.05153 5.06186ZM10.3614 18.3029C8.63873 17.7286 6.78479 16.5072 5.14123 14.8635C3.49759 13.22 2.27624 11.366 1.70197 9.64334C1.31422 8.48024 1.26648 7.47755 1.5487 6.77324L4.58984 9.81438C4.20277 10.8699 4.79483 12.4632 6.16809 13.8366C7.26466 14.9331 8.5017 15.5322 9.49308 15.5322C9.74358 15.5322 9.97826 15.4938 10.1911 15.4157L13.2315 18.4561C12.5273 18.7383 11.5245 18.6906 10.3614 18.3029Z",
    fill: "#78787D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9557 0.00585938H11.5243C10.3973 0.00585938 9.48047 0.922695 9.48047 2.0497V7.46391C9.48047 8.59091 10.3973 9.50775 11.5243 9.50775H12.5318V10.8595C12.5318 11.118 12.6778 11.3543 12.9091 11.47C13.0057 11.5183 13.1102 11.542 13.2142 11.542C13.3593 11.542 13.5034 11.4958 13.6238 11.4055L16.1541 9.50781H17.9556C19.0826 9.50781 19.9995 8.59098 19.9995 7.46398V2.0497C19.9995 0.922695 19.0827 0.00585938 17.9557 0.00585938ZM18.6344 7.46391C18.6344 7.83818 18.33 8.14263 17.9557 8.14263H15.9267C15.779 8.14263 15.6353 8.19057 15.5172 8.27913L13.8969 9.49428V8.82512C13.8969 8.44822 13.5913 8.14256 13.2143 8.14256H11.5243C11.15 8.14256 10.8456 7.83812 10.8456 7.46384V2.0497C10.8456 1.67542 11.15 1.37098 11.5243 1.37098H17.9557C18.33 1.37098 18.6344 1.67542 18.6344 2.0497V7.46391Z",
    fill: "#78787D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2227_220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyHotline);
export default __webpack_public_path__ + "static/media/Emergency-Hotline.0b61f7da5e9ad3d53e7ccc7f9cdf5421.svg";
export { ForwardRef as ReactComponent };